import React from "react";
import { Row, Col, Card, Form, Input, Space, Image } from "antd";

const { TextArea } = Input;

const Layout8 = ({ onChange, initialData }) => {
  const [form] = Form.useForm();
  const imageUrl = Form.useWatch("imageUrl", form);

  return (
    <Card
      style={{
        background: "#f9fafb",
        border: "2px dashed #1890ff",
      }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialData}
        onValuesChange={(_, allValues) => onChange(allValues)}
      >
        <Row gutter={32}>
          <Col span={10}>
            <Form.Item label="Image URL (Background image for banner)" name="imageUrl">
              <Input placeholder="Paste image URL" />
            </Form.Item>
            <Space direction="vertical">
            <div
              style={{
                width: "100%",
                border: "1px dashed #d9d9d9",
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#fff",
              }}
            >
              {imageUrl ? (
                <Image
                  src={imageUrl}
                  alt="Preview"
                  style={{
                    objectFit: "cover",
                  }}
                />
              ) : (
                <span style={{ color: "#999" }}>Image Preview</span>
              )}
            </div>

              <div>
             <Form.Item label="Buton label" name="btnLabel">
                          <Input placeholder="Our services" />
                        </Form.Item>
                        
                        <Form.Item label="Buton navigation" name="btnNav">
                          <Input placeholder="page url" />
                        </Form.Item>
              </div>
              </Space>

          </Col>
          <Col span={14}>
            {/* Title */}
            <Form.Item label="Title" name="title">
              <Input placeholder="unique business consulting" />
            </Form.Item>
            <Form.Item
              label="Description"
              name="description"
              style={{ marginBottom: 0 }}
            >
              <TextArea rows={3} placeholder="Enter description text" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default Layout8;